import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { PublicidadService } from '../publicidad.service';
import { PublicidadPreviewComponent } from '../publicidad-preview/publicidad-preview.component';

@Component({
  selector: 'app-publicidad-update',
  templateUrl: './publicidad-update.component.html',
  styleUrls: ['./publicidad-update.component.scss']
})
export class PublicidadUpdateComponent implements OnInit {

  @Input() element: any;

  fileToUpload?: File | null;
  archivo: FormControl = new FormControl();
  mensaje: FormControl = new FormControl();
  imgFile: any;
  imagenInicial: boolean = false;

  form: FormGroup = new FormGroup({});

  mostrarVistaPrevia: boolean = true;

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.mostrarVistaPrevia = window.innerWidth >= 1200;
  }

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: PublicidadService,
    public formatter: FormatterService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: ['', [Validators.required]],
      titulo: ['', [Validators.required]],
      tipo: [1, [Validators.required]],
      url: [''],
      descripcion: [''],
    });

    this.form.patchValue(this.element);
    this.convertToBlob();
    if (window.innerWidth < 1200) this.mostrarVistaPrevia = false;
  }

  guardar(): void {
    if (!this.fileToUpload) {
      this.alerts.addAlert("Debe cargar una imagen.", "warning");
      return;
    }
    if (this.form.valid) {
      this.loading.show();
      this.service.update(this.fileToUpload, this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Publicidad actualizada con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo actualizar el registro de publicidad.", "danger");
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  onImageChange(e: any): void {
    if (!e) return;
    const files = e.target.files;
    const sizeLimit = 52428800;
    if (files.item(0).size > sizeLimit) {
      this.alerts.addAlert("El archivo es demasiado grande para ser subido.", "danger");
      this.fileToUpload = null;
      return;
    }
    this.fileToUpload = files.item(0);
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.imgFile = event.target.result;
      }
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  convertToBlob(): void {
    const responseData = new Uint8Array(this.element.publicidad.data);
    if (!responseData) return;
    const blob = new Blob([responseData], { type: `image/${this.element.extension_publicidad}` });
    const file = new File([blob], `${this.element.nombre_publicidad}.${this.element.extension_publicidad}`);

    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.imgFile = event.target.result;
    }
    reader.readAsDataURL(blob);
    this.fileToUpload = file;
  }

  showPreview() {
    const modalRef = this.modalService.open(PublicidadPreviewComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true });
    modalRef.componentInstance.imgFile = this.imgFile;
    modalRef.componentInstance.element = this.form.value;
    modalRef.result.then((result: any) => { }, (reason: any) => { });
  }
}
